import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Message } from '../model/message.model';
import { avecMéthodesMessages } from './message-information.methods';

export const MessageInformationStore = signalStore(
  { providedIn: 'root' },
  withEntities<Message>(),
  avecMéthodesMessages(),
);
